import { render, staticRenderFns } from "./script-edit.vue?vue&type=template&id=32e50dc8&scoped=true&"
import script from "./script-edit.vue?vue&type=script&lang=js&"
export * from "./script-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e50dc8",
  null
  
)

export default component.exports